import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/lib/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/three-dots/dist/three-dots.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/providers/AuthProvider.tsx");
